import { useRouter } from "next/router";
import { useRef, useState } from "react";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import MainView from "./MainView";
import SearchView from "./SearchView";
import { Container, Inner } from "./styles";

export type ToolbarProps = {
  openFilters: () => void;
};

const Toolbar: React.FC<ToolbarProps> = (props) => {
  const router = useRouter();
  const { openFilters } = props;
  const innerRef = useRef<HTMLDivElement>(null);

  const [searchOpen, setSearchOpen] = useState(
    () =>
      // When you visit the page with `?q=` the searchbar should be visible
      // This feature is used by the productSearch CallToAction
      "q" in router.query
  );

  return (
    <Container>
      <SwitchTransition>
        <CSSTransition
          key={searchOpen ? "search" : "default"}
          classNames="animation"
          nodeRef={innerRef}
          addEndListener={(done) => {
            innerRef.current?.addEventListener("transitionend", done, false);
          }}
          mountOnEnter
          unmountOnExit
        >
          <Inner ref={innerRef}>
            {searchOpen ? (
              <SearchView closeSearch={() => setSearchOpen(false)} />
            ) : (
              <MainView
                openFilters={openFilters}
                openSearch={() => setSearchOpen(true)}
              />
            )}
          </Inner>
        </CSSTransition>
      </SwitchTransition>
    </Container>
  );
};

export default Toolbar;
